import React, { useEffect, useInsertionEffect, useState } from "react";
import AllDropDownsAHSF from "../../Components/AllDropDownsAHSF";
import LoaderAHSF from "../../Components/LoaderAHSF";
import ButtonAHSF from "../../Components/ButtonAHSF";
import InputAHSF from "../../Components/InputAHSF";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllItems,
  GetPR_ItemType,
  GetReportStagesFromByReportId,
  GetReportStagesToByReportId,
} from "../../Redux/Reducers/ReportStage/TransferDropDowns";
import { GetReportByAppGuid } from "../../Redux/Reducers/ReportStage/Report";
import {
  AddPR_TransferItemInformation,
  GetOnePR_TransferItemInformationByID,
  UpdatePR_TransferItemInformation,
} from "../../Redux/Reducers/ReportStage/TransferItemInformation";
import $ from "jquery";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";

const AddEditeTransferInformation = (props) => {
  const dispatch = useDispatch();

  const [itemFromDropDown, setitemFromDropDown] = useState([]);
  const [itemToDropDown, setitemToDropDown] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const state = useSelector((state) => {
    return {
      ReportStagesDropDownFrom:
        state.TransferDropDowns.ReportStagesDropDownFrom,
      ReportStagesDropDownTo: state.TransferDropDowns.ReportStagesDropDownTo,
      PR_ItemTypeList: state.TransferDropDowns.PR_ItemTypeList,
      TransferOne: state.TransferItemInformation.TransferOne,
    };
  });
  const [transferList, setTransferList] = useState({ ...state.TransferOne });
  const [itemTypeFrom, setItemTypeFrom] = useState(0);
  const [itemTypeTo, setItemTypeTo] = useState(0);
  console.log(transferList, "transferList");

  const getTransferData = async () => {
    const data = await dispatch(
      GetOnePR_TransferItemInformationByID(props.pR_TransferItemInformationGuid)
    );
    if (data.payload) {
      setTransferList({ ...data.payload });
      setItemTypeFrom(data.payload.pR_ItemTypeFrom);
      setItemTypeTo(data.payload.pR_ItemTypeTo);
      setLoading(false);
    } else {
      setTransferList({
        pR_TransferItemInformationGuid: null,
        stageFromTransfer: null,
        stageToTransfer: null,
        transferValue: null,
        pR_ReportsStagesGuid: null,
        pR_TransferInformationStatusGUID:
          "5755bdef-7263-4f2f-a4e5-e6fb6fb79df6",
        pR_ItemTypeFrom: null,
        pR_ItemTypeTo: null,
        itemFromTransfer: null,
        itemToTransfer: null,
        aI_ApplicationInformationId: localStorage.getItem(
          "aI_ApplicationInformationId"
        ),
      });
      setLoading(false);
      setShow(true);

    }
  };
  const getstages = async () => {
    const report = await dispatch(
      GetReportByAppGuid({
        aI_ApplicationInformationId: localStorage.getItem(
          "aI_ApplicationInformationId"
        ),
      })
    );

    if (report.payload) {
      const stagesFrom = await dispatch(
        GetReportStagesFromByReportId(report.payload?.pR_ReportsId)
      );

      const stagesTo = await dispatch(
        GetReportStagesToByReportId({
          reportId: report.payload?.pR_ReportsId,
          currentStage: report.payload?.pR_StagesNumberId,
        })
      );

      if (stagesFrom.payload && stagesTo.payload) {
        setShow(true);
      }
    }
  };

  const getItems = async () => {
    const allItem = await dispatch(
      GetAllItems({
        aI_ApplicationInformationId: localStorage.getItem(
          "aI_ApplicationInformationId"
        ),
        type: itemTypeFrom,
      })
    );
    if (allItem.payload?.length) {
      console.log(allItem);

      setitemFromDropDown(allItem.payload);
    }
    //----------------------------------
    const allItem2 = await dispatch(
      GetAllItems({
        aI_ApplicationInformationId: localStorage.getItem(
          "aI_ApplicationInformationId"
        ),
        type: itemTypeTo,
      })
    );
    if (allItem2.payload?.length) {
      setitemToDropDown(allItem2.payload);
    }
  };
  useEffect(() => {
    getItems();
  }, [itemTypeFrom, itemTypeTo]);
  useEffect(() => {
    getstages();
    dispatch(GetPR_ItemType());
    getTransferData();
  }, []);

  const AddTransfer = async () => {
    const add = await dispatch(AddPR_TransferItemInformation(transferList));
    if(add.payload){
        $(".close-btn").trigger("click");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تمت اضافة المعلومات بنجاح",
          showConfirmButton: false,
          timer: 1500,
          // width: "500px",
        });
        //to refresh table after action
        dispatch(setRefreshTable());
    }
  };
  const UpdateTransfer = async () => {
    const update = await dispatch(
      UpdatePR_TransferItemInformation(transferList)
    );
    if(update.payload){
        $(".close-btn").trigger("click");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم تعديل المعلومات بنجاح",
          showConfirmButton: false,
          timer: 1500,
          // width: "500px",
        });
        //to refresh table after action
        dispatch(setRefreshTable());
    }
  };
  return (
    <>
      {!loading && show ? (
        <div className="">
          <AllDropDownsAHSF
            fieldsName="stageFromTransferName"
            show={true}
            //   disabled={shouldDisableFields}
            //   value={SubSectors.aI_SubSectorId}
            defaultValue={state.TransferOne?.stageFromTransfer}
            onChange={(e) => {
              setTransferList({
                ...transferList,
                stageFromTransfer: e.target.value,
              });
            }}
            arrayOoptionList={state.ReportStagesDropDownFrom}
            KeyText={"stagesName"}
            KeyValue={"pR_ReportsStagesGuid"}
            dropdownType={"normal"}
            //   showValidationMessage={
            //     state.aI_SecondarySectorsValidate
            //       ? state.aI_SecondarySectorsValidate.includes("SubSectors")
            //       : false
            //   }
            //   validationMessage="يرجى تعبئة هذا الحقل"
          />
          <AllDropDownsAHSF
            fieldsName="itemTypeFromName"
            show={true}
            //   disabled={shouldDisableFields}
            //   value={SubSectors.aI_SubSectorId}
            defaultValue={state.TransferOne?.pR_ItemTypeFrom}
            onChange={(e) => {
              setTransferList({
                ...transferList,
                pR_ItemTypeFrom: e.target.value,
              });
              setItemTypeFrom(e.target.value);
            }}
            arrayOoptionList={state.PR_ItemTypeList}
            KeyText={"itemTypeName"}
            KeyValue={"pR_ItemTypeId"}
            dropdownType={"normal"}
            //   showValidationMessage={
            //     state.aI_SecondarySectorsValidate
            //       ? state.aI_SecondarySectorsValidate.includes("SubSectors")
            //       : false
            //   }
            //   validationMessage="يرجى تعبئة هذا الحقل"
          />
          <AllDropDownsAHSF
            fieldsName="itemFromTransfer"
            show={true}
            //   disabled={shouldDisableFields}
            //   value={SubSectors.aI_SubSectorId}
            defaultValue={state.TransferOne?.itemFromTransfer}
            onChange={(e) => {
              setTransferList({
                ...transferList,
                itemFromTransfer: e.target.value,
              });
            }}
            arrayOoptionList={itemFromDropDown}
            KeyText={"ItemName"}
            KeyValue={"itemId"}
            dropdownType={"normal"}
            //   showValidationMessage={
            //     state.aI_SecondarySectorsValidate
            //       ? state.aI_SecondarySectorsValidate.includes("SubSectors")
            //       : false
            //   }
            //   validationMessage="يرجى تعبئة هذا الحقل"
          />
          <AllDropDownsAHSF
            fieldsName="stageToTransferName"
            show={true}
            //   disabled={shouldDisableFields}
            //   value={SubSectors.aI_SubSectorId}
            defaultValue={state.TransferOne?.stageToTransfer}
            onChange={(e) => {
              setTransferList({
                ...transferList,
                stageToTransfer: e.target.value,
              });
            }}
            arrayOoptionList={state.ReportStagesDropDownTo}
            KeyText={"stagesName"}
            KeyValue={"pR_ReportsStagesGuid"}
            dropdownType={"normal"}
            //   showValidationMessage={
            //     state.aI_SecondarySectorsValidate
            //       ? state.aI_SecondarySectorsValidate.includes("SubSectors")
            //       : false
            //   }
            //   validationMessage="يرجى تعبئة هذا الحقل"
          />
          <AllDropDownsAHSF
            fieldsName="ItemTypeToName"
            show={true}
            //   disabled={shouldDisableFields}
            //   value={SubSectors.aI_SubSectorId}
            defaultValue={state.TransferOne?.pR_ItemTypeTo}
            onChange={(e) => {
              setTransferList({
                ...transferList,
                pR_ItemTypeTo: e.target.value,
              });
              setItemTypeTo(e.target.value);
            }}
            arrayOoptionList={state.PR_ItemTypeList}
            KeyText={"itemTypeName"}
            KeyValue={"pR_ItemTypeId"}
            dropdownType={"normal"}
            //   showValidationMessage={
            //     state.aI_SecondarySectorsValidate
            //       ? state.aI_SecondarySectorsValidate.includes("SubSectors")
            //       : false
            //   }
            //   validationMessage="يرجى تعبئة هذا الحقل"
          />
          <AllDropDownsAHSF
            fieldsName="itemToTransfer"
            show={true}
            //   disabled={shouldDisableFields}
            //   value={SubSectors.aI_SubSectorId}
            defaultValue={state.TransferOne?.itemToTransfer}
            onChange={(e) => {
              setTransferList({
                ...transferList,
                itemToTransfer: e.target.value,
              });
            }}
            arrayOoptionList={itemToDropDown}
            KeyText={"ItemName"}
            KeyValue={"itemId"}
            dropdownType={"normal"}
            //   showValidationMessage={
            //     state.aI_SecondarySectorsValidate
            //       ? state.aI_SecondarySectorsValidate.includes("SubSectors")
            //       : false
            //   }
            //   validationMessage="يرجى تعبئة هذا الحقل"
          />
          <InputAHSF
            fieldsName="transferValue"
            show={true}
            comma={true}
            //   disabled={shouldDisableFields || secoundName}
            defaultValue={state.TransferOne?.transferValue}
            onChange={(e) => {
              setTransferList({
                ...transferList,
                transferValue: e.target.value,
              });
            }}
            //   showValidationMessage={
            //     state.ApplicationInformationValidationPage
            //       ? state.ApplicationInformationValidationPage.includes(
            //           "secondName"
            //         )
            //       : false
            //   }
            //   validationMessage="يرجى تعبئة هذا الحقل"
          />
          {/* {!shouldDisableFields ? ( */}
          <div className="containersButton">
            <div>
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  props.pR_TransferItemInformationGuid
                    ? UpdateTransfer()
                    : AddTransfer();
                }}
                disabled={false}
                title={props.BtnClick == "edit" ? "تعديل" : "اضافة"}
                text={props.BtnClick == "edit" ? "تعديل" : "اضافة"}
                show={true}
              />
            </div>
          </div>
          {/* ) : (
          ""
        )} */}
        </div>
      ) : (
        ""
      )}
      <LoaderAHSF show={loading} />
     
    </>
  );
};
export default AddEditeTransferInformation;
